import { Avatar } from "@material-ui/core";
import defaultAvatarImage from "icons/legacy/default-avatar.svg";
import React from "react";
import { Interviewer } from "types/legacy";

type InteviewerType = Pick<Interviewer, "firstName" | "lastName" | "imageUrl">;

type InterviewerAvatarProps = {
  interviewer: InteviewerType;
  className?: string;
};

const InterviewerAvatar: React.FC<InterviewerAvatarProps> = ({
  interviewer: { firstName, lastName, imageUrl },
  className,
}) => {
  const name = `${firstName} ${lastName}`;
  return (
    <Avatar src={imageUrl} alt={`${name} Thumbnail`} className={className}>
      <img
        width="100%"
        height="100%"
        src={defaultAvatarImage.src}
        alt={`${name} Thumbnail`}
      />
    </Avatar>
  );
};

export default InterviewerAvatar;
